export default "__VITE_ASSET__20afba15__"